
import { Vue, Component, Prop } from "vue-property-decorator";
import ModalContent from "@/components/modal/ModalContent.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreen.vue";
import convertSecondsToReadable from "@/utils/convertSecondsToReadable";
import { Project_Activity_Request_More_Hours, Project_Activity } from "@/generated/graphql";
import APPROVE_PROJECT_ACTIVITY_REQUEST_MORE_HOURS from "@/apollo/projectActivities/ApproveRequestedHours.gql";
import UPDATE_PROJECT_ACTIVITY_CONFIRMED_HOURS from "@/apollo/projectActivities/UpdateProjectActivityConfirmedHours.gql";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import GET_PROJECT_ACTIVITY_REQUEST_MORE_HOURS from "@/apollo/projectActivities/GetRequstedHours.gql";
import PROJECT_ACTIVITY_REQUEST_MORE_HOURS_AGGREGATE from "@/apollo/projectActivities/ProjectActivityRequestMoreHoursAggregate.gql";

@Component({
  components: {
    ModalContent,
    ModalFullScreen,
    LoadingOverlay,
  } ,
apollo: {
  requestedHours: {
      query: GET_PROJECT_ACTIVITY_REQUEST_MORE_HOURS,
      variables() {
        return {
          activityId: this.activity?.id,
        };
      },
      update: (data) => data.project_activity_request_more_hours,
    },
    
    moreHoursRequest: {
        query: PROJECT_ACTIVITY_REQUEST_MORE_HOURS_AGGREGATE,
      variables() {
        return {
          activityId: this.activity?.id,
        };
      },
      update: (data) => data.project_activity_request_more_hours_aggregate.aggregate.sum.hours,
      },
}
})
export default class RequestedHours extends Vue {
  @Prop({ type: Object, default: true }) readonly activity!: Project_Activity;
  @Prop({ type: Number, default: 0 }) readonly confirmedHours!: Project_Activity;


  showNotes: boolean = false;
  focusedOnTime: Project_Activity_Request_More_Hours = undefined;
  declineDisabled: boolean = false;
  processing: boolean = false;
  convertSecondsToReadable = convertSecondsToReadable;
  requestedHours: Project_Activity_Request_More_Hours[] = undefined;
  moreHoursRequest: number =0;
  
  id: string = "";

  convertDateString(date: string): string {
        // date = date.replace("-", "/").replace("-", "/");
        var parts = date.split("-");
        // return date;
        return parts[2] + "/" + parts[1] + "/" + parts[0];
    }
  //   refetchData(): void {
  //     window.location.reload();
  // }

  closeModal(): void {
        this.$emit("close");
        // window.location.reload();
    }
    async approveHours(time: Project_Activity_Request_More_Hours): Promise<void> {
        this.processing = true;
        this.declineDisabled = true;
        let approveIds = [];
        approveIds.push(time.id);

        await this.$apollo.mutate({
            mutation: APPROVE_PROJECT_ACTIVITY_REQUEST_MORE_HOURS,
            variables: { ids: approveIds }
        });
        
        const activityId = time.activity_id;
        const hours = time.hours;
        await this.$apollo.mutate({
            mutation: UPDATE_PROJECT_ACTIVITY_CONFIRMED_HOURS,
            variables: {
                id: activityId,
                hours: hours
            }
        });

        await this.$apollo.queries.requestedHours.refetch();
        await this.$apollo.queries.moreHoursRequest.refetch();

        this.processing = false;
        this.declineDisabled = false;

    }
  toggleShowNotes(time: Project_Activity_Request_More_Hours): void {
        if (this.showNotes) {
            this.showNotes = false;
            this.focusedOnTime = undefined;
        } else {
            this.focusedOnTime = time;
            this.showNotes = true;
        }
    }
}
